var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProperty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.979,
    height: 36.362,
    viewBox: "0 0 36.979 36.362",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline",
    transform: "translate(-16 -24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65242",
    "data-name": "Path 65242",
    d: "M50.513,59.13V29.547h1.233a.616.616,0,0,0,.616-.616V24.617a.616.616,0,0,0-.67-.614L30.737,25.852a.616.616,0,0,0-.562.614v2.465a.616.616,0,0,0,.616.616h1.233V41.408h1.233V29.547H49.281V59.13H45.242a2.3,2.3,0,0,0,.341-1.215,2.224,2.224,0,0,0-.8-1.686c-.3-.3-.434-.452-.434-.8,0-1.531-.847-3.082-2.465-3.082S39.42,53.9,39.42,55.432c0,.346-.133.494-.434.8a2.224,2.224,0,0,0-.8,1.686,2.3,2.3,0,0,0,.341,1.215h-6.5V51.118a.616.616,0,0,0-.616-.616h-3.7a.616.616,0,0,0-.616.616V59.13H25.245V48.247l7.4-3.236,7.4,3.236v5.487h1.233V48.786l.986.431a.616.616,0,0,0,.863-.565V45.571a.616.616,0,0,0-.369-.565l-9.861-4.314a.616.616,0,0,0-.494,0l-9.861,4.314a.616.616,0,0,0-.369.565v3.082a.616.616,0,0,0,.863.565l.986-.431V59.13H19.7V48.653H22.93V47.42h-5.7V33.861H32.791V32.629H26.733l-2.285-2.285a.616.616,0,0,0-.436-.181h-4.93a.616.616,0,0,0-.616.616v1.849H16.616a.616.616,0,0,0-.616.616V48.036a.616.616,0,0,0,.616.616h1.849V59.13H16v1.233H52.979V59.13ZM31.408,27.03,51.13,25.29v3.025H31.408ZM23.4,47.71V45.974L32.64,41.93l9.245,4.045V47.71l-.616-.27V47.42h-.047l-8.334-3.646a.616.616,0,0,0-.494,0L24.059,47.42h-.047v.021ZM19.7,31.4h4.059l1.233,1.233H19.7Zm8.628,20.338h2.465v7.4H28.326Zm12.326,7.4a1.328,1.328,0,0,1-1.233-1.215c0-.358.135-.51.441-.817a2.2,2.2,0,0,0,.792-1.666c0-1.462.806-1.849,1.233-1.849.975,0,1.233,1.21,1.233,1.849a2.2,2.2,0,0,0,.792,1.666c.306.308.441.459.441.817a1.328,1.328,0,0,1-1.233,1.215Z",
    transform: "translate(0 0)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65243",
    "data-name": "Path 65243",
    d: "M240.616,384a.616.616,0,0,0-.616.616V387.7a.616.616,0,0,0,.616.616h3.7a.616.616,0,0,0,.616-.616v-3.082a.616.616,0,0,0-.616-.616Zm3.082,3.082h-2.465v-1.849H243.7Z",
    transform: "translate(-206.743 -332.266)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22481",
    "data-name": "Rectangle 22481",
    width: 1.173,
    height: 2.346,
    transform: "translate(28.903 47.46)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65244",
    "data-name": "Path 65244",
    d: "M54.779,177.4v-8.163h7.547V168H48.616a.616.616,0,0,0-.616.616v9.861a.616.616,0,0,0,.616.616h3.849v-1.233H49.233v-8.628h4.314V177.4Z",
    transform: "translate(-29.535 -132.906)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65245",
    "data-name": "Path 65245",
    d: "M264.616,124.93h3.7a.616.616,0,0,0,.616-.616v-3.7a.616.616,0,0,0-.616-.616h-3.7a.616.616,0,0,0-.616.616v3.7A.616.616,0,0,0,264.616,124.93Zm.616-3.7H267.7V123.7h-2.465Z",
    transform: "translate(-228.894 -88.604)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65246",
    "data-name": "Path 65246",
    d: "M360.616,124.93h3.7a.616.616,0,0,0,.616-.616v-3.7a.616.616,0,0,0-.616-.616h-3.7a.616.616,0,0,0-.616.616v3.7A.616.616,0,0,0,360.616,124.93Zm.616-3.7H363.7V123.7h-2.465Z",
    transform: "translate(-317.499 -88.604)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65247",
    "data-name": "Path 65247",
    d: "M264,212.465h1.233v-3.233H267.7v5.082h1.233v-5.7a.616.616,0,0,0-.616-.616h-3.7a.616.616,0,0,0-.616.616Z",
    transform: "translate(-228.894 -169.825)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65248",
    "data-name": "Path 65248",
    d: "M360,212.314a.616.616,0,0,0,.616.616h3.7a.616.616,0,0,0,.616-.616v-3.7a.616.616,0,0,0-.616-.616h-3.7a.616.616,0,0,0-.616.616Zm1.233-3.082H363.7V211.7h-2.465Z",
    transform: "translate(-317.499 -169.825)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65249",
    "data-name": "Path 65249",
    d: "M384,299.7v1.233h2.465a.616.616,0,0,0,.616-.616v-3.7a.616.616,0,0,0-.616-.616H382v1.233h3.849V299.7Z",
    transform: "translate(-339.65 -251.045)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22482",
    "data-name": "Rectangle 22482",
    width: 1.173,
    height: 1.173,
    transform: "translate(20.692 50.979)",
    fill: "#06233d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty);
export default __webpack_public_path__ + "static/media/property.9db90fcaccd1cb83d86fbc8520e1df12.svg";
export { ForwardRef as ReactComponent };